import { render, staticRenderFns } from "./VehicleTechs.vue?vue&type=template&id=1ff5e028&"
import script from "./VehicleTechs.vue?vue&type=script&lang=js&"
export * from "./VehicleTechs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports